var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDarkMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.446,
    height: 13.484,
    viewBox: "0 0 16.446 13.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(-1750 -2694.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chevron-thin-right",
    "data-name": "Icon metro-chevron-thin-right",
    d: "M5.756,6.743.158.926a.546.546,0,0,1,0-.768.534.534,0,0,1,.76,0l6.138,6.2a.546.546,0,0,1,0,.767l-6.138,6.2a.533.533,0,0,1-.76,0,.546.546,0,0,1,0-.768l5.6-5.815Z",
    transform: "translate(1759.233 2694.039)",
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 14.215,
    transform: "translate(1750.5 2700.781)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDarkMd);
export default __webpack_public_path__ + "static/media/arrow-right-dark-md.e463462ca5218d9eedcd8fdc34005ac6.svg";
export { ForwardRef as ReactComponent };